import { useEffect, useState } from "react";
import { batch, useDispatch } from "react-redux";
import { TransformModuleGroups } from "../connection/sessions";
import { updateWorkingEventSession } from "../store/actions/admin/create-event";
import { updateWorkingSession } from "../store/actions/admin/create-event/session";
import { useTypedSelector } from "../store/reducers/use-typed-selector";

// this adds the default session module grouping to sessions
// that were not created with group modules
const useTransformGroupModules = (): void => {
	const {
		CreateSessionReducer: {
			workingSession,
		},
		AuthReducer: {
			token,
		},
	} = useTypedSelector(state => state);

	const [updating, setUpdating] = useState(false);

	const dispatch = useDispatch();

	// if group modules has not been set up for this session, create them!
	useEffect(() => {
		if (token && workingSession && !workingSession?.module_grouping && !updating) {
			setUpdating(true);
			const transformModules = async () => {
				try {
					const updatedSessionWithGroupModules = await TransformModuleGroups(token, workingSession);
					batch(() => {
						dispatch(updateWorkingSession(updatedSessionWithGroupModules));
						dispatch(updateWorkingEventSession(updatedSessionWithGroupModules));
					});
				} catch (e: any) {
					console.log(e?.response || e);
				}
			};
			transformModules();
		}
	}, [workingSession, dispatch, token, updating]);
};

export default useTransformGroupModules;
